import * as React from 'react';
import { usePagination } from './hooks';
import { Pagination } from '../../components/Pagination';

export function PaginationContainer() {
  const { onPageSelect, pages, nextPage, prevPage } = usePagination();

  const handleClickPagination = React.useCallback(
    (page: number) => {
      onPageSelect(page);
    },
    [onPageSelect],
  );

  if (pages.length === 0) {
    return null;
  }

  return <Pagination nextButton={nextPage} prevButton={prevPage} pages={pages} onClick={handleClickPagination} />;
}
